import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { defaults, Pie } from 'react-chartjs-2';
import Color from 'color';

//import Chart from 'react-chartjs-2';

import oldlogo from '../../assets/images/oldlogos/logo-color.png';

import { colorForCategory, getCategoryComponents, getDimensionIdForTalent } from '../../util';
import { introForPlanYourCareer, introForPlayToYourStrengths, descriptionForPlayToStrengthsTalent, descriptionForPlayToStrengthsCategory, descriptionForTalent, descriptionForTalentCategory, descriptionForCompetency, descriptionForPlayToStrengthsTalentCategory } from '../../util/descriptions';
import { iconForTalentCategory } from '../../util/icons';

// Disable animating charts by default.

//defaults.pie.animation.animateRotate = false;
//defaults.pie.animation.animateScale = false;
defaults.global.tooltips.enabled = false;
//defaults.global.elements.arc.borderWidth = 0;
defaults.global.elements.arc.backgroundColor = 'rgba(0,0,0,.1)';

const TALENT_CATEGORIES=[{
  name: 'Motivation',
  id: 'motivation'
},{
  name: 'Interaction',
  id: 'interaction'
},{
  name: 'Execution',
  id: 'execution'
},{
  name: 'Cognition',
  id: 'cognition'
}];

class PersonPage extends Component {

  state = {
    ProfileID: null
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    this.setState({
      ProfileID: params.ProfileID
    });
  }
  componentDidMount(){

  }

  renderLoadingMessage(){
    return <p>Loading...</p>;
  }

  dataForProfile(){
    const people = this.props.users;
    const strengths = this.props.strengths;
    const scores = this.props.scores;
    const ProfileID = this.state.ProfileID;

    const matchingUserData = _.find(people, person => {
      return parseInt(person.ProfileID) === parseInt(ProfileID);
    });

    const matchingStrengthsData = _.find(strengths, strengthData => {
      return parseInt(strengthData.ProfileID) === parseInt(ProfileID);
    });

    const matchingScoreData = _.find(scores, scoreData => {
      return parseInt(scoreData.ProfileID) === parseInt(ProfileID);
    });

    if(!matchingUserData || !matchingStrengthsData || !matchingScoreData){
      return null;
    }

    return {
      user: matchingUserData,
      strengths: matchingStrengthsData.strengths,
      scores: matchingScoreData
    }
  }

  componentWillReceiveProps(){

  }

  renderPieChart(chartData){
    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={chartData} />
  }

  orderedTalentCategories(){
    const strengthScores = this.dataForProfile().strengths;
    const componentScores = this.dataForProfile().scores;

    const orderedCategories = _.sortBy(TALENT_CATEGORIES, category => {
      return -1 * strengthScores[category.id];
    });

    return _.map(orderedCategories, category => {

      const categoryComponents = getCategoryComponents(category.id);
      let categoryComponentScores = [];

      const componentScoreTotal = _.reduce(categoryComponents, (memo, componentId) => {
        const scoreForComponent = componentScores[getDimensionIdForTalent(componentId)];
        return memo + scoreForComponent;
      }, 0);

      //calculate & save percentages for each component
      _.each(categoryComponents, componentId => {
        const scoreForComponent = componentScores[getDimensionIdForTalent(componentId)];
        categoryComponentScores.push({
          name: componentId,
          score: Math.round(scoreForComponent * 100 / componentScoreTotal)
        });
      });

      return {
        ...category,
        score: strengthScores[category.id],
        components: _.sortBy(categoryComponentScores, component => {
          return -1 * component.score;
        }),
      }
    });
  }

  chartDataForCategory(category = 'all'){

    if(category === 'all'){
      const orderedTalentCategories = this.orderedTalentCategories();

      return {
        datasets: [{
          data: _.map(orderedTalentCategories, 'score'),
          backgroundColor: _.map(_.map(orderedTalentCategories, 'id'), colorForCategory)
        }]
      }
    }
    else{
      const categoryColor = Color(colorForCategory(category.id));

      return {
        datasets: [{
          data: _.map(category.components, 'score'),
          backgroundColor: [categoryColor.rgb().string(), categoryColor.fade(.2).rgb().string(), categoryColor.fade(.4).rgb().string(), categoryColor.fade(.6).rgb().string(), categoryColor.fade(.8).rgb().string()]
        }]
      }
    }
  }

  renderStrengthsScores(){
    const categories = this.orderedTalentCategories();

    return(
      <div className="strengths-scores tall">
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory('all'))}
          </div>
        </div>

        {_.map(categories, category => {
          return (
            <div key={category.id} className={`strength ${category.id}`}>
              <div className="name">{category.name}</div>
              <div className="percent" style={{color: colorForCategory(category.id)}}>{Math.round(category.score)}%</div>
              {category.score >= 30 &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Strong Category</div>
              }
            </div>
          );
        })}
      </div>
    )
  }

  renderScoresForCategory(category){

    return(
      <div className="strengths-scores">
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory(category))}
          </div>
        </div>

        {_.map(category.components, (component) => {
          return (
            <div key={component.name} className={`strength ${component.name}`}>
              <div className="name">{component.name}</div>
              <div className="percent">{Math.round(component.score)}%</div>
              {component.score >= 30 && false &&
                <div className="strong-indicator">Strong Talent</div>
              }
            </div>
          );
        })}
      </div>
    )
  }

  renderSingleScorePie(percentage, color){
    const dataForPie = {
      datasets: [{
        data: [percentage, (100 - percentage)],
        backgroundColor: [color,'rgba(0,0,0,.1)'],
      }]
    }

    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={dataForPie} />
  }

  getScoreLabel(score, isCategory){
    const roundedScore = Math.round(score);

    if(roundedScore >= 20 && roundedScore <= 29){
      return roundedScore + '%';
    }
    else if(roundedScore >= 20){
      return roundedScore + '% - Strong ' + (isCategory ? 'category' : 'talent');
    }
    else{
      return roundedScore + '% - Weak ' + (isCategory ? 'category' : 'talent');
    }
  }

  renderTalentCategories(){

    const categories = this.orderedTalentCategories();

    return(
      <div className="talents">
        {_.map(categories, category => {
          return (
            <div key={'category-definition-' + category.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{category.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(category.score, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(category.score, true)}</div>
              </div>
              <div className="talent-info">
                <p>{descriptionForTalentCategory(category.id)}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderTalentsForCategory(category){
    return(
      <div className="talents">
        {_.map(category.components, component => {
          return (
            <div key={'category-definition-' + component.name} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{component.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(component.score, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(component.score, false)}</div>
              </div>
              <div className="talent-info">
                <p>Bacon ipsum dolor amet pancetta turkey fatback tail filet mignon jowl beef porchetta t-bone. Meatball pastrami kevin beef, chuck turkey filet mignon pork loin hamburger short ribs shoulder ground round tail bacon.</p>
                <p className="competency"><small><b>Competency: Bacon</b><br/>Bacon ipsum dolor amet pancetta turkey fatback tail filet mignon jowl beef porchetta t-bone.</small></p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderFooterForPage(pageNumber){
    return (
      <div className="page-footer">
        {this.renderPreparedForUser()}
        {this.renderPageNumber(pageNumber)}
      </div>
    )
  }

  renderPreparedForUser(){
    const dataForProfile = this.dataForProfile();

    const {FirstName, LastName} = dataForProfile.user;

    return (
      <div className="prepared-for">Prepared for {FirstName} {LastName}</div>
    )
  }

  renderPageNumber(number){
    return (
      <div className="page-marker">Page {number}</div>
    )
  }

  renderCategoryPage(category, index){
    return (
      <div key={'page-' + category.id} className="report-know-your-strengths report-page">
        <img className="report-logo" width="150" height="40" src={oldlogo} />
        <h2>{category.name} Talents</h2>
        {this.renderScoresForCategory(category)}
        {this.renderTalentsForCategory(category)}
        {this.renderFooterForPage(index + 2)}
      </div>
    )
  }

  renderPlayToYourStrengthsReport(dataForProfile){

    const orderedTalentCategories = this.orderedTalentCategories();

    return (
      <template>
        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width="150" height="40" src={oldlogo} />
            <h1>Play To Your Strengths<span className="prepared-for"> - {dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
            <div className="report-section" style={{paddingTop: '0px'}} dangerouslySetInnerHTML={{__html: introForPlanYourCareer()}}></div>
            <div className="report-section full-width-with-icon">
              <div className="section-icon">{iconForTalentCategory(orderedTalentCategories[0].id)}</div>
              <div className="section-title">Your leading VELOCITY.win category: {orderedTalentCategories[0].name}</div>
              <div className="section-content large-font" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalentCategory(orderedTalentCategories[0].id)}}></div>
            </div>
            <div className="report-section no-bottom-border">
              <p>The next page will break down your top talent in each core area of impact. These are strengths that you draw upon to deliver in each core area of impact. Based on your responses to the talent inventory the following strategies have been custom created for you, based on your leading talent for each core area...</p>
            </div>
            {dataForProfile && this.renderFooterForPage(6)}
          </div>
        </div>

        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width="150" height="40" src={oldlogo} />
            <h1>Play To Your Strengths<small> - {dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</small></h1>

            {_.map(orderedTalentCategories, (talentCategory, index) => {
              return (
                <div key={'top-talent-definition-for-category-' + talentCategory.id} className={'report-section has-icon ' + (index === 3 ? 'no-bottom-border' : '')}>
                  <div className="section-icon">{iconForTalentCategory(talentCategory.id)}</div>
                  <div className="section-title">Top {talentCategory.name} Talent: <span style={{textTransform: 'capitalize'}}>{talentCategory.components[0].name}</span></div>
                  <div className="section-content" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalent(talentCategory.components[0].name)}}></div>
                </div>
              );
            })}
            {dataForProfile && this.renderFooterForPage(7)}
          </div>
        </div>
      </template>
    )
  }

  renderKnowYourStrengthsReport(dataForProfile){
    return (
      <div className="page report-export">
        <div className="report-know-your-strengths report-page">
          <img className="report-logo" width="150" height="40" src={oldlogo} />
          <h1>Know Your Strengths<small> - {dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</small></h1>
          {dataForProfile && this.renderStrengthsScores()}
          {dataForProfile && this.renderTalentCategories()}
          {dataForProfile && this.renderFooterForPage(1)}
        </div>

        {dataForProfile && _.map(this.orderedTalentCategories(), this.renderCategoryPage.bind(this))}

        {!dataForProfile && this.renderLoadingMessage()}
      </div>
    )
  }

  render(){

    const dataForProfile = this.dataForProfile();

    if(!dataForProfile || !dataForProfile.user){
      return null;
    }

    return (
      <div>
        {this.renderKnowYourStrengthsReport(dataForProfile)}
        {this.renderPlayToYourStrengthsReport(dataForProfile)}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    users: state.users,
    scores: state.scores,
    strengths: state.strengths,
  }
}

export default connect(mapStateToProps, {})(PersonPage);



// WEBPACK FOOTER //
// ./src/components/people/person.js